import React from "react";
import { css } from "@emotion/react";
import { FormattedMessage, useIntl } from "react-intl";
import Form, { SIZE, TYPE } from "components/Form";
import { Col } from "components/Containers";
import { breakpoints, colors, fontSize, margins } from "style";
import { PrimaryLink } from "components/Links";
import { RESEND_CONFIRMATION } from "graphql/mutations";
import { MUTATION_TYPE, useLinks, useToast } from "hooks";
import { useNavigate } from "react-router";

/**
 * ResendConfirmationForm
 */
const ResendConfirmationForm = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { toast } = useToast();
  const links = useLinks();

  /**
   * Handle RequestComplete
   */
  const handleComplete = () => {
    toast.success(<FormattedMessage id="Confirmation.ResendConfirmationForm.Success" />);
    navigate(links.login);
  };

  return (
    <Col>
      <span css={styles.title}>
        <FormattedMessage id="Confirmation.ResendConfirmationForm.Title" />
      </span>
      <span css={styles.subtitle}>
        <FormattedMessage id="Confirmation.ResendConfirmationForm.Subtitle" />
      </span>
      <Form
        data={FORM_DATA}
        initialValues={{ input: {} }}
        saveButton={{
          show: true,
          labelId: intl.formatMessage({ id: "Confirmation.ResendConfirmationForm.Button" }),
          props: {
            css: styles.button,
          },
        }}
        mutationData={{
          mutationName: {
            add: RESEND_CONFIRMATION,
          },
          unWrapParams: true,
        }}
        mutationType={MUTATION_TYPE.add}
        onCompleted={handleComplete}
        marginSize={margins.none}
      />
      <span css={styles.already_member}>
        <FormattedMessage
          id="Login.ForgotPasswordForm.LoginLabel"
          values={{
            link: (
              <PrimaryLink href={links.login} css={styles.link} routerEnabled>
                <FormattedMessage id="Login.ForgotPasswordForm.LoginLink" />
              </PrimaryLink>
            ),
          }}
        />
      </span>
    </Col>
  );
};

const styles = {
  title: css`
    color: ${colors.black};
    font-size: ${fontSize.xxlarge};
    margin-bottom: 1.5rem;
    font-weight: 700;
  `,
  subtitle: css`
    font-size: ${fontSize.normal};
    color: ${colors.grayAnatomyLight1};
    margin-bottom: 3rem;
    font-weight: 500;
  `,
  already_member: css`
    font-size: ${fontSize.small};
    color: ${colors.grayAnatomyLight1};
    margin: 3rem auto 0 auto;
  `,
  link: css`
    @media (max-width: ${breakpoints.mobile}) {
      color: ${colors.purpleRainLight3};
    }
  `,
  button: css`
    width: 100%;
  `,
  form_container: css`
    width: 100%;
  `,
};

const FORM_DATA = [
  {
    style: styles.form_container,
    items: [
      {
        label: "Email",
        type: TYPE.input,
        size: SIZE.xlarge,
        parentObjectKey: "input",
        properties: {
          name: "id",
          autoFocus: true,
          required: true,
          type: "email",
        },
      },
    ],
  },
];

export default ResendConfirmationForm;
